var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.initialized && _vm.display())?_c('div',{staticClass:"magic-ui-pc-container",class:_vm.className,style:(_vm.style),attrs:{"id":_vm.config.id}},[_c('magic-ui-container',{attrs:{"config":_vm.containerConfig}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }